<footer class="w-full bg-[#3a3a3a] text-white">
  <div class="max-w-6xl mx-auto px-6 pb-10">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
      <!-- LEFT: Logo + Social -->
      <div class="flex flex-col justify-between min-h-[260px]">
        <!-- Logo -->
        <div class="flex items-start gap-6">
          @if (data?.logo?.fields?.file?.url; as logoUrl) {
            <img
              [src]="logoUrl.startsWith('//') ? 'https:' + logoUrl : logoUrl"
              class="h-56 object-contain"
              alt="Logo"
            />
          }
        </div>

        <!-- Social Icons -->
        <div class="mt-10 md:mt-0 flex items-center gap-6">
          @for (
            socialMediaLink of data?.socialMediaLinks ?? [];
            track socialMediaLink?.fields?.url
          ) {
            <a
              class="inline-flex text-white items-center justify-center w-16 h-16 transition hover:text-[#E1CEB9]"
              [href]="socialMediaLink.fields.url"
              [attr.aria-label]="socialMediaLink.fields.label"
              rel="noopener noreferrer"
              target="_blank"
            >
              <fa-icon
                class="text-5xl"
                [icon]="
                  getIcon(
                    socialMediaLink?.fields?.icon.fields.icon,
                    socialMediaLink?.fields?.icon?.fields?.iconLibrary
                  )
                "
              />

              @if (
                socialMediaLink?.fields?.icon?.fields?.file?.url;
                as iconUrl
              ) {
                <img
                  [src]="
                    iconUrl.startsWith('//') ? 'https:' + iconUrl : iconUrl
                  "
                  class="w-7 h-7 md:w-8 md:h-8"
                  alt=""
                />
              }
            </a>
          }
        </div>
      </div>

      <!-- RIGHT: Navigation Links -->
      <div class="flex md:justify-end pt-6 md:pt-24">
        <nav class="text-left md:text-right">
          <ul class="space-y-2 md:space-y-3">
            @for (link of data?.links ?? []; track link?.fields?.url) {
              <li>
                @if (isExternalLink(link.fields.url)) {
                  <a
                    class="font-primary text-xl text-white md:text-2xl hover:text-[#E1CEB9] transition"
                    [href]="link.fields.url"
                  >
                    {{ link.fields.label }}
                  </a>
                } @else {
                  
                  @if (link.fields.isAnchor) {
                    <a
                      class="font-primary text-xl text-white md:text-2xl hover:text-[#E1CEB9] transition hover:cursor-pointer"
                      [appScrollAnchor]="link.fields.url"
                    >
                      {{ link.fields.label }}
                    </a>
                  } @else {
                    <a
                      class="font-primary text-xl text-white md:text-2xl hover:text-[#E1CEB9] transition hover:cursor-pointer"
                      [routerLink]="routerLinkTarget(link.fields.url)"
                    >
                      {{ link.fields.label }}
                    </a>
                  }
                }
              </li>
            }
            <li class="pt-2">
              <a
                class="font-primary text-lg text-white md:text-xl hover:text-[#E1CEB9] transition hover:cursor-pointer"
                [routerLink]="'/impressum'"
              >
                Impressum
              </a>
            </li>
            <li>
              <a
                class="font-primary text-lg text-white md:text-xl hover:text-[#E1CEB9] transition hover:cursor-pointer"
                [routerLink]="'/privacy'"
              >
                Privacy
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</footer>
